module.exports = __webpack_public_path__ + "images/xl_game_25.png?7d1adca71d489483ea618a77d58cd387";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_game_25.png
// module id = 235
// module chunks = 1